import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Title } from "react-admin";
import useUser from "../hooks/useUser";
import logo from "../assets/logo.png";
import EventHistoryTable from "../components/EventHistoryTable";
import RemoteMarkdown from "../components/RemoteMarkdown";
import "../App.css";

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Arial",
    fontSize: 16,
    width: "100%",
  },
};

export default () => {
  const user = useUser();
  const adminOrBelongToOrg =
    user.role === "super-admin" ||
    (user.Organizations && user.Organizations.length > 0);

  let message = "";

  if (user && user.Organizations && user.Organizations.length === 1) {
    const org = user.Organizations[0];
    if (user.role === "channel-admin")
      message = `a Channel Partner of ${org.name}`;
    else message = `an Organization Administrator of ${org.name}`;
  } else if (user && user.Organizations && user.Organizations.length > 1) {
    if (user.role === "channel-admin")
      message = `a Channel Partner of multiple organizations`;
    else
      message =
        message + `an Organization Administrator of multiple organizations`;
  }

  return (
    <Card>
      <Title title="SOS Technologies" />
      <CardContent>
        <div style={{ textAlign: "center" }}>
          <div style={{ height: 25 }} />
          <img
            height="150"
            src={logo}
            alt="sos logo"
            style={{
              background: "black",
              padding: "2rem",
              borderRadius: "0.25rem",
              width: "80%",
              objectFit: "contain",
            }}
          />
          <div style={{ height: 50 }} />
          {adminOrBelongToOrg && (
            <Typography variant="h4">
              You are logged in as{" "}
              {user.role === "super-admin" ? "a Super Admin User" : message}
            </Typography>
          )}
          {!adminOrBelongToOrg && (
            <Typography variant="h4">
              You don't yet belong to an Organization. Please contact your
              Organization administrator, or contact SOS to be added to an
              Organization.
            </Typography>
          )}
          <div style={{ height: 25 }} />
          <div className="dashboard-markdown">
            <RemoteMarkdown
              style={styles.wrapper}
              src="https://markdown-cloud.devon.workers.dev/api/documents/aa55a08e-4ff4-40a2-b7d1-89a6cd5da92e"
            />{" "}
          </div>
          <div style={{ height: 25 }} />
          <EventHistoryTable />
        </div>
      </CardContent>
    </Card>
  );
};
